export default "__VITE_ASSET__ByJG6pF$__"